import { CdkDrag, CdkDragHandle } from '@angular/cdk/drag-drop';
import { NgStyle } from '@angular/common';
import { AfterContentChecked, Component, ElementRef, Input, ViewChild } from '@angular/core';
import { EventsWyswygService } from 'src/app/shared/services/events-wyswyg.service';

@Component({
  selector: 'draggable-container',
  templateUrl: './draggable-container.component.html',
  styleUrls: ['./draggable-container.component.css'],
  standalone: true,
  imports: [CdkDrag, CdkDragHandle, NgStyle],
})
export class DraggableContainerComponent implements AfterContentChecked {
  @Input() prefix: string = '';

  @ViewChild('wrapper') wrapper!: ElementRef;
  @ViewChild('elementToolbar') elementToolbar!: ElementRef;
  public height!: number;

  focusModeActive = false;

  constructor(private eventsService: EventsWyswygService) { 
    this.eventsService.focusMode$.subscribe((active) => {
      this.focusModeActive = active;
    });
  }

  deleteElement(): void {
    this.eventsService.onElementDeleted(this.prefix);
    if(this.focusModeActive) {
      this.eventsService.emitFocusMode(false);
    }
  }

  duplicateElement(): void {
    this.eventsService.onElementDuplicated(this.prefix);
  }

  ngAfterContentChecked(): void {
    this.calcHeight();
  }

  calcHeight(): void {
    this.height = Math.max(this.wrapper?.nativeElement['offsetHeight'],
      this.elementToolbar?.nativeElement['offsetHeight']);
  }

}
